import Grid from '@frontend/storefront/components/grid/index';
import { h2 } from '@frontend/storefront/components/home/styles';
import ProductGridItems from '@frontend/storefront/components/layout/product-grid-items';
import { useStorefrontData } from '@frontend/storefront/data';

export default function CategoryPage() {
  const { title, products = [] } = useStorefrontData();
  return (
    <section>
      <h1 className={h2}>{title}</h1>
      {products.length === 0 ? (
        <p className="py-3 text-lg">{`No products found in this collection`}</p>
      ) : (
        <Grid className="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          <ProductGridItems products={products} />
        </Grid>
      )}
    </section>
  );
}
